"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const theme_1 = require("../theme");
/**
 * Presentational recursive tree for the hierarchical group sidebar (Van Life > Country > Region
 * > City, or a business's Company > Department > Team). No fetching — feed it a flat GroupNode[]
 * run through treeUtils.buildTree(). Each app wires its own groupHierarchyApi to the callbacks.
 */
const GroupTreeSidebar = ({ nodes, selectedId, expandedIds, onToggle, onSelect, renderBadge, style, }) => ((0, jsx_runtime_1.jsx)("div", { role: "tree", style: { display: 'flex', flexDirection: 'column', gap: 2, ...style }, children: nodes.map((node) => ((0, jsx_runtime_1.jsx)(TreeRow, { node: node, depth: 0, selectedId: selectedId, expandedIds: expandedIds, onToggle: onToggle, onSelect: onSelect, renderBadge: renderBadge }, node.id))) }));
const TreeRow = ({ node, depth, selectedId, expandedIds, onToggle, onSelect, renderBadge }) => {
    const hasChildren = node.children.length > 0;
    const isExpanded = expandedIds.has(node.id);
    const isSelected = selectedId === node.id;
    return ((0, jsx_runtime_1.jsxs)("div", { role: "treeitem", "aria-expanded": hasChildren ? isExpanded : undefined, "aria-selected": isSelected, children: [(0, jsx_runtime_1.jsxs)("div", { onClick: () => onSelect(node.id), style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    paddingLeft: 8 + depth * 16,
                    paddingRight: 8,
                    paddingTop: 8,
                    paddingBottom: 8,
                    borderRadius: theme_1.theme.radii.input,
                    background: isSelected ? theme_1.theme.colors.input : 'transparent',
                    color: isSelected ? theme_1.theme.colors.text : theme_1.theme.colors.textMuted,
                    cursor: 'pointer',
                }, children: [hasChildren ? ((0, jsx_runtime_1.jsx)("button", { type: "button", "aria-label": isExpanded ? 'Collapse' : 'Expand', onClick: (e) => {
                            e.stopPropagation();
                            onToggle(node.id);
                        }, style: {
                            background: 'none',
                            border: 'none',
                            color: 'inherit',
                            cursor: 'pointer',
                            padding: 0,
                            width: 16,
                            flexShrink: 0,
                            transform: isExpanded ? 'rotate(90deg)' : 'none',
                            transition: 'transform 0.15s ease',
                        }, children: "\u25B8" })) : ((0, jsx_runtime_1.jsx)("span", { style: { width: 16, flexShrink: 0 } })), (0, jsx_runtime_1.jsx)("span", { style: { flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }, children: node.name }), renderBadge?.(node)] }), hasChildren && isExpanded && ((0, jsx_runtime_1.jsx)("div", { role: "group", children: node.children.map((child) => ((0, jsx_runtime_1.jsx)(TreeRow, { node: child, depth: depth + 1, selectedId: selectedId, expandedIds: expandedIds, onToggle: onToggle, onSelect: onSelect, renderBadge: renderBadge }, child.id))) }))] }));
};
exports.default = GroupTreeSidebar;
